/**
 * Canonical, locale-independent identifier for the Requestor role.
 *
 * Match against `role.code` on every CP/CM role endpoint (including /me/).
 * Do NOT match against `role.name` — that field is the localized display
 * string ("Requestor" / "Demandeur") on every endpoint except /me/, and
 * /me/ may localize `name` in the future too.
 */
export const REQUESTOR_ROLE_CODE = "Client Portal Requestor Role";

/** Canonical role codes for CP users who can access continuous monitoring UI. */
export const CLIENT_PORTAL_ADMIN_ROLE_CODE = "Client Portal Admin Role";
export const CLIENT_PORTAL_MANAGER_ROLE_CODE = "Client Portal Manager Role";
export const CLIENT_PORTAL_PROXY_ROLE_CODE = "Client Portal Proxy Role";

export const CLIENT_PORTAL_MONITORING_ACCESS_ROLE_CODES = [
  CLIENT_PORTAL_ADMIN_ROLE_CODE,
  CLIENT_PORTAL_MANAGER_ROLE_CODE,
  CLIENT_PORTAL_PROXY_ROLE_CODE,
] as const;
